// extracted by mini-css-extract-plugin
export default {"layout":"Header_layout__TGTGv","contents":"Header_contents__nnzrv","displayNone":"Header_displayNone__7jl2s"};